import React, { useEffect } from 'react';
import '../styles/NotificationModal.css';

const NotificationModal = ({ type = 'info', message, isOpen, onClose, autoClose = true, duration = 4000 }) => {
  useEffect(() => {
    let timer;
    if (isOpen && autoClose) {
      timer = setTimeout(() => {
        onClose();
      }, duration);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isOpen, onClose, autoClose, duration]);

  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <i className="fas fa-check-circle"></i>;
      case 'error':
        return <i className="fas fa-exclamation-circle"></i>;
      case 'warning':
        return <i className="fas fa-exclamation-triangle"></i>;
      case 'info':
      default:
        return <i className="fas fa-info-circle"></i>;
    }
  };

  // Interceptar o clique na sobreposição para evitar o fechamento acidental
  const handleOverlayClick = (e) => {
    // Impede que cliques na sobreposição propaguem para elementos abaixo
    e.stopPropagation();
    // Fecha a notificação apenas se o autoClose estiver desativado
    if (!autoClose) {
      onClose();
    }
  };

  return (
    <div className="notification-overlay" onClick={handleOverlayClick}>
      <div 
        className={`notification-modal notification-${type}`} 
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'relative', zIndex: 10000 }}
      >
        <div className="notification-icon">
          {getIcon()}
        </div>
        <div className="notification-content">
          <p>{message}</p>
        </div>
        <button className="notification-close" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default NotificationModal; 